import React from 'react';
import { AppStore } from '../../../AppStore';
import GlyphSequence from './PreviewGlyphSequence';
import OutcomeBanner from '../OutcomeBanner';
import { ArithmeglyphsStore } from '../../_puzzles/Arithmeglyphs/ArithmeglyphsStore';
import './ArithmeglyphsPreview.less';

const ArithmeglyphsPreview = ({ onClick }: { onClick: () => void }) => {
  const puzzleData = AppStore.useState(s => s.puzzleData?.arithmeglyphs);
  if (!puzzleData) return null;

  return (
    <div className="previewTile puzzleTile arithmeglyphsTile" onClick={onClick}>
      <div className="puzzleTitle">Arithmeglyphs</div>
      <div className="arithmeglyphsPreview">
        <div className="glyphSequencesContainer">
          <GlyphSequence glyphString={puzzleData.line1_opSeq} lineNumber={0} />
          <GlyphSequence glyphString={puzzleData.line2_opSeq} lineNumber={1} />
          <OutcomeBanner store={ArithmeglyphsStore as any} />
        </div>
      </div>
    </div>
  );
};

export default ArithmeglyphsPreview;
